import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SimilarProperties.css";

function SimilarProperties({ selectedProperty }) {

  const [similarList, setSimilarList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {

    if (!selectedProperty) return;

    fetch("https://urbanbrick.in.net/realestate_new/get-properties.php")
      .then(res => res.json())
      .then(data => {

        const minPrice =
          Number(selectedProperty.price) - 100000;

        const maxPrice =
          Number(selectedProperty.price) + 100000;

        let filtered = data.filter(
          (item) =>
            item.id !== selectedProperty.id &&
            item.city === selectedProperty.city &&
            Number(item.price) >= minPrice &&
            Number(item.price) <= maxPrice
        );

        if (filtered.length < 3) {

          const cityBased = data.filter(
            (item) =>
              item.id !== selectedProperty.id &&
              item.city === selectedProperty.city
          );

          filtered = [
            ...new Set([...filtered, ...cityBased])
          ];

        }

        if (filtered.length < 3) {

          const others = data.filter(
            (item) =>
              item.id !== selectedProperty.id
          );

          filtered = [
            ...new Set([...filtered, ...others])
          ];

        }

        setSimilarList(filtered.slice(0, 3));

      })
      .catch(err => console.log(err));

  }, [selectedProperty]);

  if (!selectedProperty) return null;

  return (

    <div className="similar-container">

      {similarList.length > 0 && (
        <>
          <h3 className="similar-heading">
            Similar Properties
          </h3>

          <div className="similar-grid">

            {similarList.map((item) => (

              <div
                key={item.id}
                className="similar-card"
                onClick={() =>
                  navigate(`/property/${item.id}`)
                }
              >

                <img
                  src={
                    item.images?.length
                      ? item.images[0]
                      : "https://via.placeholder.com/150"
                  }
                  alt={item.title}
                />

                <h4>{item.title}</h4>

              </div>

            ))}

          </div>
        </>
      )}

    </div>

  );

}

export default SimilarProperties;